import { useEffect, useState } from 'react';

/**
 * Trails a value by `delayMs`.
 *
 * Used to keep a search box responsive while the request it drives fires once
 * the typing settles, rather than once per keystroke — a query key built from
 * the raw input value always misses the cache, so every character would be a
 * round trip.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
